import { type FC } from 'react';
import styled from 'styled-components';
import {
  Text10,
  Text14Medium,
  Text18Medium,
  Text64Medium,
} from '../../../mixins/mixins';
import type { IContactLine } from './types';

const ContactLineComponent = styled.div<{ isLine: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  margin-top: 64px;
  margin-right: 24px;
  padding-bottom: 64px;
  border-bottom: 1px solid rgba(7, 24, 43, 0.2);
  transition: 0.2s ease-in-out;
  margin-left: 24px;

  :before {
    transition: 0.6s;
    content: '';
    position: absolute;
    display: block;
    bottom: -1px;
    width: 100%;
    height: 8px;
    background: rgba(88, 255, 126, 0);
  }

  :last-child {
    border-bottom: 1px solid transparent;
  }

  :hover {
    transition: 0.6s;
    :before {
      transition: 0.6s;
      background: rgba(88, 255, 126, 1);
    }
  }

  @media (max-width: 669px) {
    margin-top: 22px;
    padding-bottom: 22px;
    border-bottom: 1px solid rgba(7, 24, 43, 0.2);
    :hover {
      border-bottom: 1px solid transparent;

      :before {
        content: '';
        position: absolute;
        display: none;
        bottom: -1px;
        width: 100%;
        height: 8px;
        background: rgba(88, 255, 126, 1);
      }
    }
  }
`;

const Title = styled.div`
  ${Text14Medium};
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 32px;
  @media (max-width: 669px) {
    ${Text10};
    margin-bottom: 24px;
  }
`;

const ContactWrapper = styled.a`
  display: flex;
  align-items: center;
`;

const ContactInfo = styled.span`
  ${Text64Medium};
  font-size: 54px;
  color: rgba(0, 0, 0, 1);
  text-decoration: none;
  @media (max-width: 669px) {
    ${Text18Medium};
  }
`;

const ContactLine: FC<IContactLine> = ({ data, isLine }) => (
  <ContactLineComponent key={data.title} isLine={isLine}>
    <Title>{data.title}</Title>
    <ContactWrapper href={data.href}>
      <ContactInfo>{data.targetContact}</ContactInfo>
      <img src="/assets/img/FooterImages/LinkArrow.svg" alt="Link Arrow" className="linkArrowIco" />
    </ContactWrapper>
  </ContactLineComponent>
);

export default ContactLine;
